<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
    <newscards newsSource="engadget"></newscards>
    <rsscards newsSource="macrumors" displayTitle="MacRumors" displayThumb="true" className="macrumors card-with-image"></rsscards>
   
    <newscards newsSource="techcrunch"></newscards>
    <newscards newsSource="techradar"></newscards>
    <newscards newsSource="wired"></newscards> 
    <newscards newsSource="the-verge"></newscards>
    <newscards newsSource="hacker-news"></newscards>
    <newscards newsSource="recode"></newscards>
  </v-container>
</template>

<script>
export default {
  name: 'Technology'
}
</script>
